import React, { useEffect } from "react";
import FAQS4 from "../Components/FAQS4";
import HowWorks4 from "../Components/HowWorks4";
import img from "../assets/crypto.jpg";
import Calculator4 from "../Components/Calculator4";
import Navbar from "../Components/Navbar";
import { useAuthContext } from "../Contexts/AuthContext";
import { useState } from "react";
import { useNavigate,Link } from "react-router-dom";
import play from "../assets/play.png";

const Home2 = () => {
  const { userdata, user } = useAuthContext()
  const navigate = useNavigate()
  const [modal, setModal] = useState(user ? userdata.kyc : true);

  useEffect(() => {
    const ScrollToTop = () => {
      window.scrollTo(0, 0);
    };
    ScrollToTop();
  }, []);

  return (
    // Walletven
    <div className="home2">
      <Navbar />

      <div className={`d-flex align-items-center mt-10 canvas 
     rounded p-md-3 justify-content-between ${window.matchMedia("(max-width: 850px)").matches && "flex-column"}`}>
        <div className="how_works2 w-50">
          <h1 className="hero_h">
            Compra y envía
            Criptomonedas.<br />
            Simple y Seguro.
          </h1>
          <div className="mt-3">
            <p>
              Realiza tus envíos a Venezuela a través de USDT directamente a wallets digitales. También puedes adquirir otras Criptomonedas populares y comprar desde Venezuela consultando con tu Agente Transferven.
            </p>
 <div className="d-flex mt-2">
            <Link to={"https://play.google.com/store/apps/details?id=com.transferven.app"} target="_blank"> 
            <img src={play} width={150} className="me-3" />
            </Link>
          </div> 
          </div>
        </div>
        <Calculator4 />
      </div>
      <HowWorks4 />
      <FAQS4 />
      <div className="mt-5"></div>
      <div className="canvas bg-white shadow rounded p-3">
        <div className="col-md-10 col-12 mx-auto text-center">
          La inversión en criptoactivos no está regulada, puede no ser adecuada para inversores minoristas y perderse la totalidad del importe invertido.
          Es importante leer y comprender los riesgos de esta inversión que se explican detalladamente en esta <a href="./Advertencia de riesgos de Criptoactivos TRANSFERVEN.pdf" target="_blank">ubicación</a>.
        </div>
      </div>

      <div className="OrderSection">
      {!modal && (
        <div
          className="modal_bg d-flex justify-content-center 
          align-items-center"
        >
          <div
            className="modal"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog payment_dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    ¡Aviso! Completa tus datos personales.
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setModal(true);
                    }}
                  ></button>
                </div>
                <div className="modal-body">
                  Como empresa regulada, estamos obligados a verificar la Identidad de todos los usuarios en operaciones no presenciales, mediante el empleo de procedimientos seguros de identificación. Este proceso se realiza solo una vez.
                </div>
                <div className="modal-footer">
                  <p
                    className="continue w-auto fs-6 px-4 py-2 mt-0"
                    style={{ whiteSpace: "nowrap" }}
                    target="_blank"
                    type="button"
                    onClick={() => navigate(user ? `/profile?edit=true` : "/login")}
                  >
                    Completar
                  </p>
                  <button
                    type="button"
                    className="btn btn-secondary ms-3"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setModal(true);
                    }}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default Home2;
